import './App.css'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'
import { HelmetProvider } from 'react-helmet-async';
import { lazy, Suspense } from 'react'
import { NavigationProvider } from './hooks/useNavigation';

//styles
import './App.css'

// page components
import Home from './pages/home/Home'
import Login from './pages/login/Login'
import Signup from './pages/signup/Signup'
//import Document from './pages/document/Document'
//import Dashboard from './pages/dashboard/Dashboard'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
//import MyInfo from './pages/myInfo/MyInfo'
//import Progress from './pages/development/Progress'
//import Developer from './pages/development/Developer'
import LoggingIn from './pages/signup/LoggingIn'
import Feedback from './pages/feedback/Feedback'
import AboutUs from './pages/aboutus/AboutUs'
//import ContactPage from './pages/contact/ContactPage'
//import PnsPage from './pages/pns/PnsPage'
//import Search from './pages/search/Search'
//import SubscriptionSelection from './pages/stripe/SelectSubscription'
//import ContactBook from './pages/contact/ContactBook'
//import PnsBook from './pages/pns/PnsBook'*/

// code splitting
//const Home = lazy(() => import('./pages/home/Home'))
//const Login = lazy(() => import('./pages/login/Login'))
//const Signup = lazy(() => import('./pages/signup/Signup'))
const Document = lazy(() => import('./pages/document/Document'))
const Dashboard = lazy(() => import('./pages/dashboard/Dashboard'))
//const Navbar = lazy(() => import('./components/Navbar'))
//const Footer = lazy(() => import('./components/Footer'))
const MyInfo = lazy(() => import('./pages/myInfo/MyInfo'))
const Progress = lazy(() => import('./pages/development/Progress'))
const Developer = lazy(() => import('./pages/development/Developer'))
//const LoggingIn = lazy(() => import('./pages/signup/LoggingIn'))
const PnsPage = lazy(() => import('./pages/pns/PnsPage'))
const Search = lazy(() => import('./pages/search/Search'))
const SubscriptionSelection = lazy(() => import('./pages/stripe/SelectSubscription'))
const ContactBook = lazy(() => import('./pages/contact/ContactBook'))
const PnsBook = lazy(() => import('./pages/pns/PnsBook'))
const ContactPage = lazy(() => import( './pages/contact/ContactPage'))


function App() {
  const { user, customClaims, authIsReady } = useAuthContext()

  return (
    <HelmetProvider>
      <div className="App">
      
        {authIsReady && (
          <BrowserRouter>

            <div className="container">
              <Navbar />

              {user && !user.emailVerified && <span className="error">{console.log(user)}Please verify your e-mail and refresh this page or login again</span>}
              
              <Suspense fallback={<div>Loading...</div>}>
                <NavigationProvider>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="home" element={<Home />} />
                  <Route path="subscriptionselection" element={<SubscriptionSelection />} />
                  <Route 
                    path="login" 
                    element={user ? <Navigate to="/dashboard" /> : <Login />} 
                  />
                  <Route 
                    path="signup" 
                    element={user ? <Navigate to="/login" /> : <Signup />} 
                  />
                  <Route
                    path="loggingin"
                    element={user ? <LoggingIn /> : <Login />}
                  />
                  <Route 
                    path="dashboard" 
                    element={user ? (user.emailVerified ? <Dashboard /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="contactpage/:id"
                    element={user ? (user.emailVerified ? <ContactPage /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="contactpage"
                    element={user ? (user.emailVerified ? <ContactPage /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="pnspage/:id"
                    element={user ? (user.emailVerified ? <PnsPage /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="pnspage"
                    element={user ? (user.emailVerified ? <PnsPage /> : <MyInfo />) : <Login />} 
                  />
                  <Route 
                    path="document/:id" 
                    element={user ? (user.emailVerified ? <Document /> : <MyInfo />) : <Login />} 
                  />
                  <Route 
                    path="document/" 
                    element={user ? (user.emailVerified ? <Document /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="myinfo"
                    element={user ? <MyInfo /> : <Navigate to ="/login" />}
                  />
                  <Route 
                    path="feedback" 
                    element={user ? <Feedback /> : <Signup />}
                  />
                  <Route 
                    path="aboutus"
                    element={<AboutUs/>}
                  />
                  <Route
                    path="progress"
                    element={<Progress />}
                  />
                  <Route 
                    path="developer"
                    element={user && customClaims.accessLevel && customClaims.accessLevel.isDeveloper ? <Developer /> : <Navigate to="/login" />}
                    //element={<Developer />}
                  />
                  <Route
                    path="contactbook/"
                    element={user ? (user.emailVerified ? <ContactBook /> : <MyInfo />) : <Login />} 
                  />
                  <Route
                    path="pnsbook/"
                    element={user ? (user.emailVerified ? <PnsBook /> : <MyInfo />) : <Login />} 
                  />
                  <Route 
                    path="search" 
                    element={user ? (user.emailVerified ? <Search /> : <MyInfo />) : <Login />} 
                  />
                  
                  <Route path="*" element={<h2>404 Not Found</h2>} />
                </Routes>
                </NavigationProvider>

              </Suspense>
              <Footer />
            </div>
          </BrowserRouter>
        )}
      
      </div>
    </HelmetProvider>
  )
}

export default App;
